<div class="flex justify-center">
  <video autoplay muted loop playsinline>
    <source src="./assets/animations/404.mp4" type="video/mp4">
  </video>
</div>
